import { api, ApiResponse } from './api';

export interface UploadedAttachment {
  id: string;
  workspace_id: string;
  uploaded_by: string;
  attachable_type: string;
  attachable_id: string | null;
  filename: string;
  original_name: string;
  mime_type: string;
  size: number;
  url: string;
  is_image: boolean;
  created_at: string;
}

export const uploadApi = {
  /**
   * Upload a file to a workspace.
   * Returns an unattached Attachment record that can be linked to a comment/item/etc.
   */
  upload: async (
    workspaceId: string,
    file: File,
    category: 'items' | 'comments' | 'changelog' | 'avatars' | 'general' = 'comments',
    entityId?: string
  ): Promise<UploadedAttachment> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);
    if (entityId) {
      formData.append('entity_id', entityId);
    }

    const response = await api.post<ApiResponse<UploadedAttachment>>(
      `/api/v1/workspaces/${workspaceId}/uploads`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data.data!;
  },

  /**
   * Delete an uploaded file.
   */
  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/api/v1/workspaces/${workspaceId}/uploads/${id}`);
  },
};
